/**
 * Global utility functions & polyfills
 */

//Cached version of jQuery getScript()
jQuery.cachedScript = function(url, async, options) {

    // Allow user to set any option except for dataType, cache, and url
    options = $.extend( options || {}, {
        dataType: "script",
        cache: true,
        url: url,
        async: typeof async !== "undefined" ? async : true
    });

    // Use $.ajax() since it is more flexible than $.getScript
    // Return the jqXHR object so we can chain callbacks
    return jQuery.ajax( options );
};

//Responsive Breakpoints
var isTablet, isMobile900, isMobile;

if ($(document).width() <= 1024) {
    if ($(document).width() <= 900 && $(document).width() > 720) {
        isMobile900 = true;
    }
    if ($(document).width() > 720) {
        isTablet = true;
    } else {
        isMobile = true;
    }
}

//Returns the elements not in common between two arrays
Array.prototype.diff = function(a) {
    return this.filter(function(i) {return a.indexOf(i) < 0;});
};


/**
 * jQuery getScript() wrapper to support multiple script loading.
 */
$.getMultiScripts = function(arr, async) {
    var _arr = $.map(arr, function(src) {
        return $.cachedScript(src, async);
    });

    _arr.push($.Deferred(function( deferred ){
        $( deferred.resolve );
    }));

    return $.when.apply($, _arr);
}

/**
 * Module loader.
 */
var loader = (function() {

	var libs = {
		external : {
			modernizr : ACC.config.commonResourcePath + "/vendors/js/modernizr.min.js",
			slimscroll : ACC.config.commonResourcePath + "/vendors/js/jquery.slimscroll.min.js",
			owlcarousel : ACC.config.commonResourcePath + "/js/owl.carousel.js",
			cookie : ACC.config.commonResourcePath + "/vendors/js/jquery.cookie.min.js",
			touchswipe : ACC.config.commonResourcePath + "/vendors/js/jquery.touchswipe.min.js",
			form : ACC.config.commonResourcePath + "/vendors/js/jquery.form-3.09.min.js",
			formstyler : ACC.config.commonResourcePath + "/vendors/js/jquery.formStyler.min.js",
			tweetscroll : ACC.config.commonResourcePath + "/vendors/js/jquery.tweetscroll.min.js",
			isotope : ACC.config.commonResourcePath + "/vendors/js/isotope.pkgd.min.js",
			readmore : ACC.config.commonResourcePath + "/vendors/js/readmore.min.js",
			validationengine : ACC.config.commonResourcePath + "/vendors/js/jquery.validationEngine.min.js",
			dotdotdot : ACC.config.commonResourcePath + "/vendors/js/jquery.dotdotdot.min.js",
			floatthead : ACC.config.commonResourcePath + "/vendors/js/jquery.floatThead.min.js",
			ve_locale : ACC.config.commonResourcePath + "/build/js/languages/jquery.validationEngine-" + currentLocale + ".min" + GSEB.constants.staticResourcesVersionFile + ".js",
            mbytplayer : ACC.config.commonResourcePath + "/vendors/js/jquery.mb.YTPlayer.min.js",
            datatable :ACC.config.commonResourcePath +"/vendors/js/datatables.min.js"
    },
		modules : {
			ellipsis : ACC.config.commonResourcePath + "/build/js/modules/plp/ellipsis.min" + GSEB.constants.staticResourcesVersionFile + ".js",
			socialnewsslider : ACC.config.commonResourcePath + "/build/js/modules/pdp/socialnewsslider.min" + GSEB.constants.staticResourcesVersionFile + ".js",
			featuresslider : ACC.config.commonResourcePath + "/build/js/modules/pdp/featuresslider.min" + GSEB.constants.staticResourcesVersionFile + ".js",
			scrollablelame : ACC.config.commonResourcePath + "/build/js/modules/pdp/scrollablelame.min" + GSEB.constants.staticResourcesVersionFile + ".js",
			reparabilityajaxsearch : ACC.config.commonResourcePath + "/build/js/modules/reparability/ajaxsearch.min" + GSEB.constants.staticResourcesVersionFile + ".js",
			scrollabletablecompare : ACC.config.commonResourcePath + "/build/js/modules/comparator/scrollabletablecompare.min" + GSEB.constants.staticResourcesVersionFile + ".js",
			themefilters : ACC.config.commonResourcePath + "/build/js/modules/enjoyrowenta/themefilters.min" + GSEB.constants.staticResourcesVersionFile + ".js",
			specialoffers : ACC.config.commonResourcePath + "/build/js/modules/specialoffers/specialoffers.min" + GSEB.constants.staticResourcesVersionFile + ".js",
			twittersnippets : ACC.config.commonResourcePath + "/build/js/modules/community/twittersnippet.min" + GSEB.constants.staticResourcesVersionFile + ".js",
			cookiehandler : ACC.config.commonResourcePath + "/build/js/modules/cookies/cookiehandler.min" + GSEB.constants.staticResourcesVersionFile + ".js",
			bgyoutubeplayer : ACC.config.commonResourcePath + "/build/js/modules/home/bgyoutubeplayer.min" + GSEB.constants.staticResourcesVersionFile + ".js",
			modernizrsnippets : ACC.config.commonResourcePath + "/build/js/modules/utilities/modernizrsnippets.min" + GSEB.constants.staticResourcesVersionFile + ".js",
			productcomparator : ACC.config.commonResourcePath + "/build/js/modules/comparator/productcomparator.min" + GSEB.constants.staticResourcesVersionFile + ".js",
			csscontactus : ACC.config.commonResourcePath + "/build/js/modules/contactus/csscontactus.min" + GSEB.constants.staticResourcesVersionFile + ".js",
			sliderhomeaccessories : ACC.config.commonResourcePath + "/build/js/modules/accessory/sliderhomeaccessories.min" + GSEB.constants.staticResourcesVersionFile + ".js",
			slider4 : ACC.config.commonResourcePath + "/build/js/modules/pdp/slider4.min" + GSEB.constants.staticResourcesVersionFile + ".js",
			slider5 : ACC.config.commonResourcePath + "/build/js/modules/pdp/slider5.min" + GSEB.constants.staticResourcesVersionFile + ".js",
			carouseldetailproduct : ACC.config.commonResourcePath + "/build/js/modules/pdp/carouseldetailproduct.min" + GSEB.constants.staticResourcesVersionFile + ".js",
			sliderhome: ACC.config.commonResourcePath + "/build/js/modules/home/sliderhome.min" + GSEB.constants.staticResourcesVersionFile + ".js",
			ourapplicationsslider: ACC.config.commonResourcePath + "/build/js/modules/ourapplications/ourapplicationsslider.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            processModal: ACC.config.commonResourcePath + "/build/js/modules/pdp/process-modal.min" + GSEB.constants.staticResourcesVersionFile + ".js",
			cookiemanager : ACC.config.commonResourcePath + "/build/js/cookie.manager.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            plpAjax: ACC.config.commonResourcePath + "/build/js/modules/plp/plp.ajax.min" + GSEB.constants.staticResourcesVersionFile + ".js",
            datatableDesignedfor : ACC.config.commonResourcePath + "/build/js/modules/accessory/datatableDesignedFor.min"+ GSEB.constants.staticResourcesVersionFile+".js",
		}
	};

	var loadedDeps = [];

    const MODULES = {
        ".accessoires .item .caption p, .accessories-item .caption p, .list-product .range .list-content .caption .excerpt" : {
        	async: false,
            executable: libs.modules.ellipsis,
            dependencies: [libs.external.dotdotdot]
        },
        ".social-news-slider" : {
            executable: libs.modules.socialnewsslider,
            dependencies: [libs.external.dotdotdot, libs.external.readmore]
        },
        ".features-slider" : {
            executable: libs.modules.featuresslider,
            dependencies: [libs.external.readmore]
        },
        "#search-filter_reparability" : {
        	async:false,
            executable: libs.modules.reparabilityajaxsearch,
            dependencies: [libs.external.readmore]
        },
        "#ScrollabeTableCompare" : {
            executable:  libs.modules.scrollabletablecompare,
            dependencies: [libs.external.floatthead]
        },
        "#container" : {
            executable: libs.modules.themefilters,
            dependencies: [libs.external.isotope]
        },
        ".special-offers-v2-container" : {
        	async: false,
            executable:  libs.modules.specialoffers,
            dependencies: [libs.external.isotope]
        },
        ".tweets-list-container" : {
            executable: libs.modules.twittersnippets,
            dependencies: [libs.external.tweetscroll]
        },
        ".scrollable-lame" : {
            executable:  libs.modules.scrollablelame,
            dependencies: [libs.external.touchswipe]
        },
        ".cookie" : {
            executable: libs.modules.cookiehandler,
            dependencies: [libs.external.cookie]
        },
        ".rowenta-portal" :{
        	dependencies: [libs.modules.cookiemanager]
        },
        "#video-wrapper" :{
        	executable:  libs.modules.bgyoutubeplayer,
        	dependencies: [libs.external.mbytplayer]
        },
        "#ScrollabeTableCompare tbody tr, .gocompare" :{
        	executable:  libs.modules.productcomparator,
        	dependencies: [libs.external.formstyler]
        },
        "#CountryFormData, #captchaerror, #AjaxContact, #ModalFeedback, #FormContact, [id^=Step], #FullFormContact, #FormContactActions, #ContactAddress, #RequestFormContact, #ContactFormCaptcha, profil-contact-select" :{
        	executable: libs.modules.csscontactus,
        	dependencies: [libs.external.validationengine, libs.external.ve_locale]
        },
        "#ModalMessage, #ModalPassword, #ModalExplodedViews, .nostock, [class^='validate'], [data-analytics-contactFormSubmit], #FormStockAlert, #updatePasswordForm, #FormUserIds" : {
        	dependencies: [libs.external.validationengine, libs.external.ve_locale]
        },
        ".js-carousel" : {
        	executable: libs.modules.sliderhomeaccessories
        },
        ".slider-4" : {
        	executable: libs.modules.slider4
        },
        ".slider-5, #ifuSelector" : {
        	executable: libs.modules.slider5
        },
        "#CarouselDetailProduct, .carousel-product-mobile" : {
        	executable: libs.modules.carouseldetailproduct
        },
        ".mini-banner-slider" : {
        	async: false,
        	executable: libs.modules.sliderhome,
        	dependencies: [libs.external.dotdotdot]
        },
        ".our-applications-carousel" : {
        	executable: libs.modules.ourapplicationsslider
        },
        ".page-productDetails #CarouselDetailProduct .thumbnails .thumbnail a, #CarouselDetailProductBig, #CarouselDetailProduct": {
            executable: [libs.modules.processModal],
            dependencies: [libs.modules.processModal]
        },
        "#plp-facets-section, #plp-results-section, #plp-pagination-section" : {
            async: false,
            executable: libs.modules.plpAjax,
            dependencies: [libs.modules.productcomparator]
        },
        "#designedfor-section": {
            async: false,
            executable: libs.modules.datatableDesignedfor,
            dependencies: [libs.external.datatable, libs.external.datatableResponsive]
        }
    };

    var loadDeps = function () {
        $.each(MODULES, function(selector, module) {
        	if($(selector).length){

        		var asyncLoad = typeof module.async !== "undefined" ? module.async : true;

        		if(typeof module.dependencies !== "undefined"){
        			if(typeof module.executable !== "undefined"){
        				$.getMultiScripts(module.dependencies.diff(loadedDeps), asyncLoad).done($.cachedScript(module.executable, asyncLoad));
        			} else {
        				$.getMultiScripts(module.dependencies.diff(loadedDeps), asyncLoad);
        			}
        			loadedDeps = loadedDeps.concat(module.dependencies.diff(loadedDeps));
        		} else if(typeof module.executable !== "undefined") {
        			$.cachedScript(module.executable, asyncLoad);
        		}

        	}
        });
    };

    return {
    	loadDeps: loadDeps
    };

}());

loader.loadDeps();
